﻿import { createContext, useContext as useReactContext } from 'react';

import { AssignedAccessCode, AssignedStudent, ContentDeliverable, License, MostRestrictiveLicense, Transaction, TransactionDetails } from 'apis/TransactionApi';
import { DEFAULT_TAB_CONTEXT, TabsContext, useContext } from 'components/Tabs';
import type { GroupsContextValue } from 'pages/groups/GroupsWrapper';
import { StudentGroupWithDetails } from 'apis/StudentGroupApi';
import { Instructor } from 'apis/InstructorApi';
import { Student } from 'apis/StudentApi';
import { Country } from 'apis/CountryApi';

export interface GroupData {
    accessCodes?: AssignedAccessCode[];

    // not in use but need to stay here
    activity?: any;
    allInstructors?: Instructor[];
    content?: ContentDeliverable[];
    contentOriginal?: ContentDeliverable[];
    countries?: Country[];

    defaultAccessCode?: string;
    groupDetails?: StudentGroupWithDetails;
    groupDetailsOriginal?: StudentGroupWithDetails;
    inactiveOrders?: License[];
    licenseHistory?: License[];
    licenses?: License[];
    mostRestrictiveLicense?: MostRestrictiveLicense;
    performance?: any;

    // true while the non-Details tab data is still loading in the background
    secondaryLoading?: boolean;
    studentList?: Student[];
    students?: AssignedStudent[];
    testContent?: ContentDeliverable[];

    // these are from the assingmentDefaultContext
    transactionDetails?: TransactionDetails;
    transactionDetailsOriginal?: TransactionDetails;
    transactions?: Transaction[];
}

export const GroupsContext = createContext<GroupsContextValue>({
    permissions: {
        ContentSelect: false,
        Create: false,
        Edit: false,
        ExpiringLicense: false,
        IsPostFiltering: false,
        MyClassrooms: false,
        OverviewPermission: false,
        Search: false,
        ShowExpiringLicenseModal: true,
        StudentFeatureFlag: false,
        StudentPermission: false,
        TransactionFeatureFlag: false,
        TransactionPermission: false
    },
    setStudentsWindow: () => undefined,
    setTransactionsWindow: () => undefined,
    studentPermissions: {
        ArchivedStudents: false,
        CourseReporting: false,
        CustomFieldsFlag: false,
        Edit: false,
        EditPII: false,
        EditUsername: false,
        GroupPermission: false,
        Import: false,
        IsPostFiltering: false,
        Login: false,
        NewFieldAccess: false,
        OverviewPermission: false,
        PartnerId: 0,
        PartnerType: 0,
        Search: false,
        TransactionFeatureFlag: false,
        TransactionPermission: false,
        ViewPII: false
    }
});
GroupsContext.displayName = 'GroupsContext';

export const useGroups = () => useReactContext(GroupsContext);

export const GroupDetailsContext = createContext<TabsContext<GroupData>>(DEFAULT_TAB_CONTEXT);
GroupDetailsContext.displayName = 'GroupDetailsContext';

export const useGroupDetails = () => useContext(GroupDetailsContext);
